import { Component } from '@angular/core';
import { Router } from '@angular/router';

type Item = {
    display: string;
    href: string;
}

@Component({
    selector: 'app-management-layout',
    templateUrl: './management-layout.component.html',
    styleUrl: './management-layout.component.scss',
    standalone: false
})
export class ManagementLayoutComponent {
    selectedIndex: number | undefined = undefined;
    items: Item[] = [
        { display: "USERS", href: "/users" },
        { display: "GROUPS", href: "/groups" }
    ];

    constructor(private router: Router) {
        this.items.forEach((i, idx) => {
            if (i.href === this.router.url) this.selectedIndex = idx;
        })
    }

    onItemClick = (idx: number, href: string) => {
        this.selectedIndex = idx;
        this.router.navigate([href]);
    }
}
